export const COMPANY_TYPE_OVERLAP = [
  { id: "AGENCY", label: "AGENCY" },
  { id: "CUSTOMS_BROKER", label: "CUSTOMS BROKER" },
  { id: "FORWARDER", label: "FORWARDER" },
  { id: "SUPPLIER", label: "SUPPLIER" },
  { id: "TRUCKER", label: "TRUCKER" },
  { id: "VESSEL_CARRIER", label: "VESSEL CARRIER" },
  { id: "WAREHOUSE", label: "WAREHOUSE" },
  { id: "TERMINAL", label: "TERMINAL" },
  { id: "CBAM_OPERATOR", label: "CBAM OPERATOR" },
  { id: "GOODS_SUPPLIER", label: "GOODS SUPPLIER" },
  { id: "CBAM_INSTALLATION", label: "CBAM INSTALLATION" },
];

export const BOOL = [
  {
    label: "Yes",
    id: true,
  },
  {
    label: "No",
    id: false,
  },
];

export const FLOW_OF_GOODS = ["IMPORT", "EXPORT"];
export const ROUTES = [
  { id: "ORIGIN_CHARGE", label: "Origin Charge" },
  { id: "FREIGHT", label: "Freight" },
  { id: "INSURANCE", label: "Insurance" },
  { id: "UNLOADING", label: "Unloading" },
  { id: "CUSTOMS", label: "Customs" },
  { id: "DELIVERY", label: "Delivery" },
  { id: "WAREHOUSING", label: "Warehousing" },
];
export const SERVICE_TYPE = [
  {
    label: "Active Service",
    id: "ACTIVE",
  },
  {
    label: "Passive Service",
    id: "PASSIVE",
  },
];

export const SERVICE_TYPE_SIMPLE = {
  ACTIVE: "Active",
  PASSIVE: "Passive",
} as const;

export const ROLE = [
  {
    label: "Administrator",
    id: "Administration",
  },
  {
    label: "Operations",
    id: "Operations",
  },
  {
    label: "WMS + Operations",
    id: "WMS+Operations",
  },
  {
    label: "Sales",
    id: "Sales",
  },
  {
    label: "Supplier",
    id: "Supplier",
  },
  {
    label: "Customer",
    id: "Customer",
  },
];

export const MACRO_CATEGORY = [
  {
    id: "NORMAL",
    label: "Camion normale",
  },
  {
    id: "CONTAINER",
    label: "Camion contenitore",
  },
  {
    id: "TRAIN",
    label: "Treno",
  },
  {
    id: "EXCEPTIONAL",
    label: "Camion eccezionale",
  },
];

export const CURRENCY = ["EUR", "USD", "GBP", "JPY", "CHF", "CNY"];
export const structureOptions = {
  NORMAL: "Normal Service",
  SERVICE: "With Sub-Services",
  CNTR_RANGE: "With Ranges",
  // TIME_RANGE: "With Ranges",
  // TIME_RANGE: "With Sub-Services and Ranges",
};

export type StructureType =
  | "NORMAL"
  | "SERVICE"
  | "CNTR_RANGE"
  | "TIME_RANGE"
  | "GUARANTEE_RANGE";
